var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { checkType } from '../checkType/checkType';
/**
 * Checks if a given value is an empty object.
 * @param val - The value to check.
 * @returns `true` if `val` is an empty object, otherwise `false`.
 */
var isEmptyObject = function (val) {
    return checkType(val, 'object') &&
        val !== null &&
        !Array.isArray(val) &&
        Object.keys(val).length === 0;
};
/**
 * Recursively removes query parameters from an object that are empty strings, null, or empty objects.
 * @param obj - The object to clean.
 * @returns A new object with the specified query parameters removed.
 */
export var clearQueryParams = function (obj) {
    var cleanedObject = __assign({}, obj);
    for (var key in cleanedObject) {
        if (Object.prototype.hasOwnProperty.call(cleanedObject, key)) {
            var value = cleanedObject[key];
            if (value === '' || value === null || isEmptyObject(value)) {
                delete cleanedObject[key];
            }
            else if (checkType(value, 'object')) {
                var nestedObject = clearQueryParams(value);
                if (!isEmptyObject(nestedObject)) {
                    cleanedObject[key] = nestedObject;
                }
                else {
                    delete cleanedObject[key];
                }
            }
        }
    }
    return cleanedObject;
};
